'use client'

import { ToastContainer } from 'react-toastify'

const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="bottom-right"
      toastClassName="*:!self-center"
      hideProgressBar={true}
      theme="light"
      pauseOnHover={false}
      autoClose={8000}
      limit={3}
    />
  )
}

export default CustomToastContainer
